/**
 * @file shipping-defaults.ts
 *
 * Default and empty shop-settings values for the Shipping tab, ported from
 * the design-reviewed Website Builder v2: the default settings used before the
 * real settings load, and the blank pickup-location factory used to seed the
 * "add pickup" form. The immutable shipping vocabulary (method ids, region
 * sentinel, requirement options) lives in `shipping-constants.ts`.
 */

import type { PickupLocationInput, ShopSettings } from '../api/shop-types';

/** Default shop settings used before the real settings load. */
export const DEFAULT_SHOP_SETTINGS: ShopSettings = {
  title: '',
  email: '',
  language: 'en',
  date_format: '',
};

/**
 * Builds a blank pickup-location input for seeding the "add pickup" form.
 *
 * @returns An empty {@link PickupLocationInput}.
 */
export function createEmptyPickupLocation(): PickupLocationInput {
  return {
    name: '',
    address: {
      address_1: '',
      city: '',
      state: '',
      postcode: '',
      country: '',
    },
    details: '',
  };
}
